module.exports = __webpack_public_path__ + "static/media/right-arrow-1.54c243bf.svg";